import React from "react";
import { Layout, } from "antd";

const { Footer } = Layout;

export function SiteFooter() {
  return (
    <Footer style={{ padding: '15px' }}>
      <div className="text-center">
        <small>
          Copyright © 2024 深圳未瓴科技有限公司
        </small>
      </div>
    </Footer>
  );
}

